import Dialog from "@rio-cloud/rio-uikit/Dialog";
import {SurchargeTimeDefinitionForm} from "./SurchargeTimeDefinitionForm.tsx";
import {useSurchargeTimeDefinitionContext, useSurchargeTimeDefinitionFormContext} from "./context.ts";


export const FormDialog = () => {
    const {showDialog, closeDialog} = useSurchargeTimeDefinitionFormContext()

    const currentId = useSurchargeTimeDefinitionContext(state => state.currentId)

    return <Dialog show={showDialog}
                   title={currentId ? "Update" : "Create Surcharge Definition"}
                   body={<SurchargeTimeDefinitionForm onCancel={() => closeDialog()} id={currentId}/>}
                   onClose={() => closeDialog()}

    />
}